import React, { useEffect, useState } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import PurchaseTable from './PurchaseTable';
import ExportBar from './ExportBar';
import PropTypes from 'prop-types';

const PurchaseSection = ({ title, fetchApi, exportApi }) => {
  const [data, setData] = useState([]);
  const [year, setYear] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 4 }, (_, i) => currentYear - i);
  const [columnType, setColumnType] = useState(0);
  const [isExporting, setIsExporting] = useState(false);

  useEffect(() => {
    if (year !== '') {
      loadData();
    }
  }, [year, columnType]);

  const loadData = async () => {
    const res = await fetchApi(year, columnType);
    if (res?.success) setData(res.data);
  };

  const handleExport = async () => {
    setIsExporting(true);
    try {
      const from = fromDate.toLocaleDateString('en-CA'); // "2026-01-01"
      const to = toDate.toLocaleDateString('en-CA'); // "2026-01-02"
      await exportApi(from, to, columnType);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div style={{ marginBottom: '35px' }}>
      <h5 style={{ fontWeight: 'bold' }} className="mb-3">
        {title.toUpperCase()}
      </h5>

      <Row className="mb-3">
        <Col xs={12} sm={6} md={4} lg={3}>
          <Form.Select value={year} onChange={e => setYear(e.target.value)}>
            <option value="">Select year</option>
            {years.map(y => (
              <option key={y}>{y}</option>
            ))}
          </Form.Select>
        </Col>

        <Col xs={12} sm={6} md={4} lg={3}>
          <Form.Select
            value={columnType}
            onChange={e => setColumnType(Number(e.target.value))}
          >
            <option value={0}>Created Date</option>
            <option value={1}>Required Date</option>
          </Form.Select>
        </Col>
      </Row>

      {/* Table */}
      <PurchaseTable data={data} />

      {/* Export */}
      <ExportBar
        fromDate={fromDate}
        toDate={toDate}
        setFromDate={setFromDate}
        setToDate={setToDate}
        onExport={handleExport}
        isExporting={isExporting}
      />
    </div>
  );
};

PurchaseSection.propTypes = {
  title: PropTypes.string.isRequired,
  fetchApi: PropTypes.func.isRequired,
  exportApi: PropTypes.func.isRequired
};

export default PurchaseSection;
